const staticdata = "https://pp.propelld.com/api/static";
const customer = "https://pp.propelld.com/api/customer";
const propelldLoan = "https://pp.loan.propelld.com/";

const baseUrls = {
	customer,
	staticdata,
	propelldLoan,
};

export default baseUrls;
